/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssFilterChipComponent } from '../filter-chip/filter-chip.component';

export interface FilterChipItem<T = any> {
  text: string;
  value: T;
  removable?: boolean;
}

@Component({
  selector: 'umss-filter-chip-group',
  standalone: true,
  imports: [CommonModule, UmssFilterChipComponent],
  templateUrl: './filter-chip-group.component.html',
  styleUrls: ['./filter-chip-group.component.scss']
})
export class UmssFilterChipGroupComponent<T> {
  @HostBinding('style.display') display = 'contents';

  /** Content props */
  @Input() chips: FilterChipItem<T>[] = []; // Array of filter chip items
  @Input() showClearAll: boolean = true; // Show "Clear All" button
  @Input() clearAllText: string = 'Clear All'; // Text for clear all button

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular'; // Size for all chips
  @Input() variant: 'Default' | 'Outlined' = 'Default'; // Visual variant for all chips

  /** Event emitters */
  @Output() chipClick = new EventEmitter<T>(); // Emits when a chip is clicked
  @Output() chipRemove = new EventEmitter<T>(); // Emits when a chip is removed
  @Output() clearAll = new EventEmitter<void>(); // Emits when "Clear All" is clicked

  /** Event handlers */
  onChipClick(value: T) {
    this.chipClick.emit(value);
  }

  onChipRemove(value: T) {
    this.chipRemove.emit(value);
  }

  onClearAllClick() {
    this.clearAll.emit();
  }

  /** Helper to check if there are any chips */
  get hasChips(): boolean {
    return this.chips && this.chips.length > 0;
  }
}
